export const initObjectives = (): void => {
  const cards = document.querySelectorAll('.reveal-card');
  if (cards.length === 0) return;

  cards.forEach(card => {
    const cardEl = card as HTMLElement;
    const starsContainer = cardEl.querySelector('.stars-container') as HTMLElement | null;

    if (starsContainer) {
      // 1. Generate Twinkling Stars inside card
      generateStars(starsContainer);
    }
  });
};

function generateStars(container: HTMLElement): void {
  container.innerHTML = '';
  const starCount = 35; // Number of twinkling stars per card

  for (let i = 0; i < starCount; i++) {
    const star = document.createElement('span');
    
    // Randomized positions
    const top = Math.random() * 100;
    const left = Math.random() * 100;
    
    // Randomized animation delays & durations for natural twinkle
    const duration = Math.random() * 15 + 15; // 15s to 30s
    const delay = Math.random() * -20; // negative delay to start immediately
    const opacity = Math.random() * 0.7 + 0.3;

    star.style.position = 'absolute';
    star.style.top = `${top}%`;
    star.style.left = `${left}%`;
    star.style.width = '2px';
    star.style.height = '2px';
    star.style.backgroundColor = '#D9A136'; // Gold stars
    star.style.borderRadius = '50%';
    star.style.opacity = opacity.toString();
    star.style.zIndex = '1';
    
    // CSS Twinkle animation simulation
    star.style.animation = `twinkle ${duration}s infinite linear`;
    star.style.animationDelay = `${delay}s`;

    container.appendChild(star);
  }
}
